import { render } from "./FuturesBalanceActionGraphWidgetLayout.vue?vue&type=template&id=dd627bda"
import script from "./FuturesBalanceActionGraphWidgetLayout.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceActionGraphWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script